import {
  LOAN_APPLICATION_FETCH_SUCCESS,
  UPDATE_COMMITMENTS_SUCCESS,
  UPDATE_ASSETS_SUCCESS,
  UPDATE_LOAN_SUMMARY_SUCCESS,
  UPDATE_PROFILE_FAILURE,
  LOAN_APPLICATION_USER_GOBACK_SUCCESS,
  LOAN_APPLICATION_USER_GOTO_SUCCESS,
  LOAN_APPLICATION_USER_VERIFY_FAILURE,
  LOAN_APPLICATION_USER_VERIFY_SUCCESS,
  UPDATE_PROFILE_SUCCESS,
} from './../actions/types'

const profile = (state={}, {type, payload}) => {
  let flowState, primary, secondary = null
  if (payload && payload.applicationFlow) {
    flowState = payload.applicationFlow.loanApplicationUser.flowState
    primary = payload.applicationFlow.profile;
    secondary = payload.applicationFlow.secondaryProfile;
  } else if (payload && payload.profile) {
    const loanApplicationUser = payload.loanApplicationUser;
    flowState =  loanApplicationUser && loanApplicationUser.flowState
    primary = payload.profile;
    secondary = payload.secondaryProfile;
  }
  const isPrimary = flowState === 'personal_details'
  switch(type) {
    case LOAN_APPLICATION_USER_GOBACK_SUCCESS:
      if (primary || secondary) {
        return isPrimary ? primary : secondary
      }
      return state;
    case UPDATE_ASSETS_SUCCESS:
    case UPDATE_PROFILE_SUCCESS:
    case LOAN_APPLICATION_USER_VERIFY_SUCCESS:
      primary = state.primary ? state.primary : primary
      secondary = state.secondary ? state.secondary : secondary
      if (payload.profile || payload.secondaryProfile) {
        payload.currentApplicant === 'primary' ?  primary = payload.profile : secondary = payload.secondaryProfile
      }
      if (primary || secondary) {
        return isPrimary ? primary : secondary
      }
      return state;
    case LOAN_APPLICATION_USER_GOTO_SUCCESS:
    case LOAN_APPLICATION_FETCH_SUCCESS:
      if (primary || secondary) {
        return isPrimary ? primary : secondary
      }
      return state;
    case UPDATE_COMMITMENTS_SUCCESS:
    case UPDATE_LOAN_SUMMARY_SUCCESS:
    case UPDATE_PROFILE_FAILURE:
    case LOAN_APPLICATION_USER_VERIFY_FAILURE:
      return payload.profile || state

    default:
      return state
  }
}

export default profile;
